import { action } from "typesafe-actions";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../api/api";
import { saveLoaderCompleted, saveLoaderProgress, showMessage } from "../messages/messagesActions";
import { IRenewals } from "./renewals.types";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { generateAdvanceFilterQuery } from "../Accounting/AccountingReports/AccountingReportsActions";

// <----------Renewals Actions-------->
export const CLEAR_TASK_RENEWALS = "CLEAR_TASK_RENEWALS";
export const clearRenewalsList = () => action(CLEAR_TASK_RENEWALS);
export const FETCH_TASK_RENEWALS_LIST_PROGRESS =
  "FETCH_TASK_RENEWALS_LIST_PROGRESS";
export const FETCH_TASK_RENEWALS_LIST_SUCCESS =
  "FETCH_TASK_RENEWALS_LIST_SUCCESS";
export const FETCH_TASK_RENEWALS_LIST_FAILED =
  "FETCH_TASK_RENEWALS_LIST_FAILED";

export const fetchRenewalsListProgress = () =>
  action(FETCH_TASK_RENEWALS_LIST_PROGRESS);
export const fetchRenewalsListSuccess = (
  list: IRenewals[],
  totalRecords: number
) => action(FETCH_TASK_RENEWALS_LIST_SUCCESS, { list, totalRecords });
export const fetchRenewalsListFailed = () =>
  action(FETCH_TASK_RENEWALS_LIST_FAILED);

export const fetchRenewalsListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    status: string,
    searchValue: IDatatableV2AdvancedSearchFilter,
    selectedDayValue: string,
    line_of_business: any,
    setTypeOfPolicy: any,
    setTableName: any,
    groupType: string,
    searchState: { [key: string]: any }
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      const { from_date, to_date, customer_policy_id, line_of_business: lobFilter, ...finalSearchState } = searchState;
      const query = generateAdvanceFilterQuery(finalSearchState);
      dispatch(fetchRenewalsListProgress());
      let finalUrl = `/policy/get-all-customer-renewal-details?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${from_date}&to_date=${to_date}`;
      if (line_of_business === undefined) {
        setTypeOfPolicy("All Policies");
        setTableName("latest_all_customer_policy_details");
      } else if (line_of_business === "Business Policy") {
        finalUrl = `/policy/get-policy-business-customer-info?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${from_date}&to_date=${to_date}`;
        setTypeOfPolicy("Business Policies");
        setTableName("latest_policy_business_customer_info");
      } else if (line_of_business === "Automobile Policy") {
        finalUrl = `/policy/get-policy-auto-customer-info?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${from_date}&to_date=${to_date}`;
        setTypeOfPolicy("Automobile Policies");
        setTableName("latest_policy_automobile_customer_info");
      } else if (line_of_business === "Commercial Auto Policy") {
        finalUrl = `/policy/get-policy-commauto-customer-info?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${from_date}&to_date=${to_date}`;

        setTypeOfPolicy("Commercial Auto Policies");
        setTableName("latest_policy_commauto_customer_info");
      } else if (line_of_business === "Habitational Policy") {
        finalUrl = `/policy/get-habitational-customer-info?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${from_date}&to_date=${to_date}`;

        setTypeOfPolicy("Habitational Policies");
        setTableName("latest_policy_habitational_customer_info");
      } else if (line_of_business === "Life & Financial Policy") {
        finalUrl = `/policy/get-life-policy-basic-details-customer-info?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${from_date}&to_date=${to_date}`;

        setTypeOfPolicy("Life & Financial Policies");
        setTableName("latest_policy_life_basic_details_customer_info");
      }

      if (query) {
        finalUrl = finalUrl + "&" + query;
      }

      // Handle line_of_business multi-select with IN operator
      if (Array.isArray(lobFilter) && lobFilter.length > 0) {
        const lobFilterObj = {
          column: ["line_of_business"],
          operator: "IN",
          value: lobFilter,
          logicalOperator: "AND",
        };
        finalUrl += "&advanceFilter=" + encodeURIComponent(JSON.stringify(lobFilterObj));
      }

      if (searchValue.length > 0) {
        finalUrl = finalUrl + `&advanceFilter=${JSON.stringify(searchValue)}`;
      }
      if (selectedDayValue) {
        finalUrl = finalUrl + "&date_column=create_ts";
      }
      if (status !== "-1") {
        finalUrl = finalUrl + `&column=${"policy_status"}&value=${status}`;
      }
      if (groupType !== "-1") {
        finalUrl += "&group_of=" + groupType;
      }
      const res = await api.get(finalUrl);

      const data: IRenewals[] = res.data.data;
      const totalRecords = res.data.totalRecords;

      dispatch(fetchRenewalsListSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchRenewalsListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };


  export const downloadRenewalsListPDFAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    selectedDayValue: string,
    status: string,
    groupType: string,
    searchState: { [key: string]: any },
    onCallback: () => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const { from_date, to_date, customer_policy_id, line_of_business: lobFilter, ...finalSearchState } = searchState;
      const query = generateAdvanceFilterQuery(finalSearchState);
    let finalUrl = `/policy/get-all-customer-renewal-details-pdf`;
    const queryParts: string[] = [];

      if (query) {
        queryParts.push(query);
      }

      // Handle line_of_business multi-select with IN operator
      if (Array.isArray(lobFilter) && lobFilter.length > 0) {
        const lobFilterObj = {
          column: ["line_of_business"],
          operator: "IN",
          value: lobFilter,
          logicalOperator: "AND",
        };
        queryParts.push("advanceFilter=" + encodeURIComponent(JSON.stringify(lobFilterObj)));
      }

      if (selectedDayValue) {
        queryParts.push("date_column=create_ts");
      }
      if (status !== "-1") {
        queryParts.push(`column=policy_status&value=${status}`);
      }
      if (groupType !== "-1") {
        queryParts.push("group_of=" + groupType);
      }

      if (queryParts.length > 0) {
        finalUrl += "?" + queryParts.join("&");
      }
      const res = await api.get(
        finalUrl,
        {
          responseType: "arraybuffer",
        }
      );

      const pdfBuffer = res.data;

      const pdfBlob = new Blob([pdfBuffer], { type: "application/pdf" });

      const pdfUrl = URL.createObjectURL(pdfBlob);

      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = "Renewals.pdf";
      link.click();

      URL.revokeObjectURL(pdfUrl);
      onCallback();
    } catch (err: any) {
      // dispatch(fetchAutomobileOcep17Failed(ERROR_MESSAGES.SERVER_ERROR));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };
